import { render, staticRenderFns } from "./notificationsProgramming.vue?vue&type=template&id=a65e7eea&"
import script from "./notificationsProgramming.vue?vue&type=script&lang=js&"
export * from "./notificationsProgramming.vue?vue&type=script&lang=js&"
import style0 from "./notificationsProgramming.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports